import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPrescribedNameActivities(id: string | undefined) {
  return useQuery(queries.products.getPrescribedNameActivitiesById(id || ''))
}
